import React from "react";
import { Card, Box, Grid, Skeleton, Stack } from "@mui/material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";

export const HelpHeroSkeleton = () => (
  <Card
    sx={{
      p: { xs: 3, sm: 4 },
      borderRadius: borderRadiusPx.xl,
      backgroundColor: colors.dashboard.cardBg,
      border: `1px solid ${colors.dashboard.cardBorder}`,
      boxShadow: customShadows.cardFlat,
      mb: 4,
    }}
  >
    <Grid container spacing={3.5} alignItems="center">
      <Grid item xs={12} lg={7}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: borderRadiusPx.lg }} />
            <Box sx={{ width: "65%" }}>
              <Skeleton variant="text" width="90%" height={38} />
              <Skeleton variant="text" width="60%" height={18} />
            </Box>
          </Stack>
          <Skeleton variant="text" width="95%" height={22} />
          <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: borderRadiusPx.xl, maxWidth: 540 }} />
          <Stack direction="row" spacing={1.5}>
            <Skeleton variant="rounded" width={140} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
            <Skeleton variant="rounded" width={160} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={5}>
        <Grid container spacing={2}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={6} key={i}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: borderRadiusPx.lg,
                  bgcolor: colors.slate[50],
                  border: `1px solid ${colors.slate[200]}`,
                }}
              >
                <Skeleton variant="text" width="60%" height={18} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="80%" height={30} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width="50%" height={16} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  </Card>
);

export const HelpVideoSkeleton = ({ count = 6 }) => (
  <Grid container spacing={3}>
    {Array.from({ length: count }).map((_, index) => (
      <Grid item xs={12} sm={6} lg={4} key={index}>
        <Card
          sx={{
            borderRadius: borderRadiusPx.xl,
            backgroundColor: colors.dashboard.cardBg,
            border: `1px solid ${colors.dashboard.cardBorder}`,
            boxShadow: customShadows.cardFlat,
            overflow: "hidden",
          }}
        >
          <Skeleton variant="rectangular" width="100%" sx={{ paddingTop: "56.25%" }} />
          <Box sx={{ p: 2.5 }}>
            <Skeleton variant="rounded" width={90} height={20} sx={{ mb: 1.5, borderRadius: borderRadiusPx.sm }} />
            <Skeleton variant="text" width="85%" height={24} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="100%" height={18} />
            <Skeleton variant="text" width="70%" height={18} />
          </Box>
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default HelpHeroSkeleton;
